/*
 * @Description: 
 * @Author: weig
 * @Date: 2021-06-11 15:54:16
 * @LastEditors: weig
 * @LastEditTime: 2021-12-17 11:17:40
 */
import request from '../../utils/request'
import EnumConfig from '../../enum/EnumConfig'

var CURR_API_VERSION = EnumConfig.EnumConfig.API_VIEW_VERSION.CURR_API_VIEW_VERSION;
var API_VERSION = CURR_API_VERSION == 'V0' ? '' : `/S/${CURR_API_VERSION}`;

//获取余额列表信息
export const GetBalancePage = (params)=>{
    return request.apiGet(`/api${API_VERSION}/Fund/Fund/GetBalancePage`, params);
}
//获取冻结余额列表信息
export const GetFrozenBalancePage = (params)=>{
    return request.apiGet(`/api${API_VERSION}/Fund/Fund/GetFrozenBalancePage`, params);
}


